var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRugbyShirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.034 3.18l-3.213-.39L16.857 1l-2.73 2.49L11.397 1l-.965 1.79-3.213.39L3 7.766v16.887h3.542V11.296L7.3 9.953V27h13.654V9.953l.736 1.343v13.357H25V7.766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.036 2.53l.024.003c.07.018.117.086.112.16l-.004.024-.62 2.753a.145.145 0 01-.214.098l-.019-.013-2.88-2.382a.157.157 0 01-.024-.214.142.142 0 01.183-.04l.022.015 2.7 2.233.568-2.52a.148.148 0 01.129-.117h.023z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.699 2.534a.145.145 0 01.168.09l.008.023.568 2.52 2.7-2.233a.142.142 0 01.187.005l.018.02a.158.158 0 01-.005.196l-.02.019-2.88 2.381a.144.144 0 01-.225-.062l-.007-.023-.62-2.753a.153.153 0 01.108-.183z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.009 3.294c.2 0 .365.114.386.26l.002.032v6.299c0 .16-.174.291-.388.291-.2 0-.365-.113-.386-.26l-.002-.031V3.586c0-.161.174-.292.388-.292z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.38 1h.942l1.402.016 1.776.031c.087.002.156.167.155.368 0 .181-.058.33-.132.357l-.029.004-1.268-.023-1.228-.017-.905-.006-1.319.007-.192.007-.018.002c-.08.08-.172-.004-.206-.189-.035-.184.002-.399.08-.48a.064.064 0 01.017-.01l.042-.016.04-.009.08-.011.184-.015.253-.01.325-.006z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

export default SvgRugbyShirt;